import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../redux/actions/app';

import { getMetadata } from '../services/tm/index';

// get tm metadata request
export function* watchGetTmMetadata() {
  yield takeEvery(ga.GET_TM_METADATA_REQUEST, function* ({ payload }) {
    yield fork(getTmMetadataWorker, payload);
  });
}
function* getTmMetadataWorker(payload) {
  try {
    const response = yield call(getMetadata, payload);
    yield put(ga.getTMMetadataSuccess(response));
  } catch (error) {
    //silence failback
  }
}
